// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import './jquery'
import './rails-ujs'
import 'core-js/stable' // ES6 polyfills
import 'regenerator-runtime/runtime' // more polyfills
import 'dom4' // DOM API polyfills
import 'promise-polyfill'
// Bootstrap datepicker
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js'
import 'unpoly'

import './components'
import './macros'
import './modals'
import './support'

import '../assets/stylesheets/application.scss'
